module.exports = __webpack_public_path__ + "static/media/_melilla.c0f45032.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_melilla.svg
// module id = 2338
// module chunks = 7